import { default as React, ReactNode } from "react";
import { LanguageContext } from "../../i18n/LanguageContext";

// Needed to avoid errors due to emotion's css prop.
import type {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  default as _2
} from "@emotion/core";

import {
  TranslationStrings,
  TranslationStringsProvider
} from "../../i18n/TranslationStringsContext";
import { AnalyticsProvider, SiteArea } from "../../utils/analytics";

import { WindowLocation } from "@reach/router";
import "@reach/skip-nav/styles.css";
import { GlobalMenus } from "../../model/menu";
import { ConsentProvider } from "../../utils/compliance";
import { IsRtlContext } from "../../utils/LayoutContext";
import { LocationProvider } from "../../utils/useGatsbyLocation";
import ModalManagerProvider from "../../utils/useModalManager";
import SessionSettingsProvider from "../../utils/useSessionSettings";

export interface ProvidersProps {
  menus: GlobalMenus;
  children: ReactNode;
  location: WindowLocation;
  strings: TranslationStrings;
  siteArea: SiteArea;
  language: string;
}

const Providers = ({
  language,
  location,
  strings,
  siteArea,
  children
}: ProvidersProps) => {
  language = language || "en";
  const isRtl = dirForLanguage(language) === "rtl";
  return (
    <ConsentProvider>
      <AnalyticsProvider siteArea={siteArea}>
        <LocationProvider location={location}>
          <LanguageContext.Provider value={language}>
            <IsRtlContext.Provider value={isRtl}>
              <SessionSettingsProvider>
                <ModalManagerProvider>
                  <TranslationStringsProvider strings={strings}>
                    {children}
                  </TranslationStringsProvider>
                </ModalManagerProvider>
              </SessionSettingsProvider>
            </IsRtlContext.Provider>
          </LanguageContext.Provider>
        </LocationProvider>
      </AnalyticsProvider>
    </ConsentProvider>
  );
};

export default Providers;

const dirForLanguage = (language: string): string | undefined => {
  switch (language) {
    case "ar":
      return "rtl";
    default:
      return "ltr";
  }
};
